import Config from '@/config'
import * as Sentry from '@sentry/vue'

const enData = 'AhaSlides_English.json'
const viData = 'AhaSlides_Vietnamese.json'
const esData = 'AhaSlides_Spanish.json'
const seData = 'AhaSlides_Swedish.json'
const ptData = 'AhaSlides_Portuguese_BR.json'
const frData = 'AhaSlides_French.json'
const deData = 'AhaSlides_German.json'
const idData = 'AhaSlides_id.json'
const itData = 'AhaSlides_Italian.json'
const trData = 'AhaSlides_Turkish.json'
const jaData = 'AhaSlides_Japanese.json'
const nlData = 'AhaSlides_Dutch.json'
const ruData = 'AhaSlides_Russian.json'
const plData = 'AhaSlides_Polish.json'
const daData = 'AhaSlides_Danish.json'
const zhData = 'AhaSlides_Traditional_Chinese.json'
const slData = 'AhaSlides_Slovenia.json'
const siData = 'AhaSlides_Slovenia.json'
const lvData = 'AhaSlides_lv.json'
const elData = 'AhaSlides_Greek.json'
const csData = 'AhaSlides_Czech.json'
const ltData = 'AhaSlides_Lithuanian.json'
const hrData = 'AhaSlides_Croatian.json'
const isData = 'AhaSlides_Icelandic.json'
const bgData = 'AhaSlides_Bulgarian.json'
const roData = 'AhaSlides_Romanian.json'
const skData = 'AhaSlides_Slovak.json'
const huData = 'AhaSlides_Hungary.json'
const sqData = 'AhaSlides_Albanian.json'
const krData = 'AhaSlides_Korean.json'
const noData = 'AhaSlides_Norwegian.json'
const srLatData = 'AhaSlides_Serbian_Latin.json'
const srCyrData = 'AhaSlides_Serbian_Cyrillic.json'
const azData = 'AhaSlides_Azerbaijani.json'

const messages = {
  en: enData,
  vi: viData,
  es: esData,
  pt: ptData,
  fr: frData,
  de: deData,
  id: idData,
  it: itData,
  tr: trData,
  ja: jaData,
  nl: nlData,
  ru: ruData,
  pl: plData,
  da: daData,
  zh: zhData,
  sl: slData,
  si: siData,
  lv: lvData,
  se: seData,
  el: elData,
  cs: csData,
  lt: ltData,
  hr: hrData,
  is: isData,
  bg: bgData,
  ro: roData,
  sk: skData,
  hu: huData,
  sq: sqData,
  kr: krData,
  no: noData,
  'sr-latn': srLatData,
  'sr-cyrl': srCyrData,
  az: azData,
}

const loadJSON = async (url) => {
  // nếu fetch có sẵn thì dùng luôn
  if (typeof window.fetch === 'function') {
    const res = await fetch(url)
    if (!res.ok) throw new Error(`Request failed with status ${res.status}`)
    return res.json()
  }

  // fallback XHR (dùng async/await với callback wrapper)
  const xhr = new XMLHttpRequest()
  xhr.open('GET', url, true)
  xhr.responseType = 'json'

  // eslint-disable-next-line promise/avoid-new
  return new Promise((resolve, reject) => {
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(xhr.response || JSON.parse(xhr.responseText))
      } else {
        reject(new Error(`Request failed with status ${xhr.status}`))
      }
    }
    xhr.onerror = () => reject(new Error('Network error'))
    xhr.send()
  })
}

export const getPresentingLanguageFromCdn = async (locale) => {
  let data = null
  try {
    if (!messages[locale]) {
      locale = 'en'
    }
    data = await loadJSON(`${Config.audienceUrl}/languages/${messages[locale]}`)
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        locale,
      },
    })
    // do nothing
  }
  return data
}
